// extracted by mini-css-extract-plugin
export var bullets = "plp_groupsnav-module--bullets--bf7ab";
export var callouts = "plp_groupsnav-module--callouts--8a531";
export var cont = "plp_groupsnav-module--cont--51463";
export var count = "plp_groupsnav-module--count--da974";
export var desc = "plp_groupsnav-module--desc--6d66d";
export var dsk_arrowbtn = "plp_groupsnav-module--dsk_arrowbtn--23c07";
export var fill_space = "plp_groupsnav-module--fill_space--c2bac";
export var forw = "plp_groupsnav-module--forw--781c0";
export var gnav_cont = "plp_groupsnav-module--gnav_cont--b96b1";
export var gnav_groups = "plp_groupsnav-module--gnav_groups--81d7d";
export var gnav_wr = "plp_groupsnav-module--gnav_wr--974a1";
export var group_btn = "plp_groupsnav-module--group_btn--999d6";
export var groups = "plp_groupsnav-module--groups--ffeec";
export var head = "plp_groupsnav-module--head--68fbf";
export var head_btns = "plp_groupsnav-module--head_btns--748d5";
export var image = "plp_groupsnav-module--image--9cf25";
export var mob_arrowbtn = "plp_groupsnav-module--mob_arrowbtn--8f0d7";
export var off = "plp_groupsnav-module--off--200b1";
export var test_bar = "plp_groupsnav-module--test_bar--6e47b";
export var title = "plp_groupsnav-module--title--34eb7";
export var titlea = "plp_groupsnav-module--titlea--b3c03";